import { useEffect } from 'react';

import { sendScreenEvent } from 'src/utils/analytics';
import { useAtlassianUser } from 'src/hooks/useAtlassianUser';
import { useReferrer } from 'src/hooks/useReferrer';

interface UseScreenEventOptions {
  eventName: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  additionalData?: Record<string, any>;
}

/**
 * Custom hook to send screen events with user and referrer information
 * @param options - Configuration object containing eventName and optional additionalData
 */
export const useScreenEvent = ({ eventName, additionalData = {} }: UseScreenEventOptions): void => {
  const { user, isLoading, hasError } = useAtlassianUser();
  const { referrerPath, isInitialized } = useReferrer();

  useEffect(() => {
    if (!isLoading && !hasError && isInitialized) {
      const eventData = {
        learningReferrerPath: referrerPath,
        ...additionalData,
      };

      sendScreenEvent(eventName, eventData, user?.account_id);
    }
  }, [eventName, user, isLoading, hasError, referrerPath, isInitialized, additionalData]);
};
